import * as React from "react";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  stroke?: string;
  fill?: string;
}
const CheckBoxChecked = (props: Props) => (
  <svg
  width="19"
  height="20"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  {...props}
>
  <defs>
    <path
      id="a"
      d="M0 4.516L2.003 3.45 8.488 0 17 4.516v8.982L8.5 18 0 13.498z"
    ></path>
  </defs>
  <use
    stroke={props.stroke || "#E7AE23"}
    xlinkHref="#a"
    transform="translate(1 1)"
    fill={props.fill || "#E7AE23"}
  ></use>
</svg>
);

export default CheckBoxChecked;
